import { Component, Input, OnInit } from '@angular/core';
import { SNAgenda } from 'src/app/models/snagenda';
import { SNAgendaAppointment } from 'src/app/models/snagendaappointment';
import { SNAgendaDay } from 'src/app/models/snagendaday';

@Component({
  selector: 'app-agenda-appointment-table',
  templateUrl: './agenda-appointment-table.component.html',
  styleUrls: ['./agenda-appointment-table.component.scss']
})
export class AgendaAppointmentTableComponent implements OnInit {

  public appointments: SNAgendaAppointment[] = [];
  public displayedColumns = ['appointment'];
  @Input() show: string[] = [];
  private theAgenda: SNAgendaDay;

  constructor() { }

  ngOnInit(): void {
  }

  @Input() set agenda(theAgenda: SNAgendaDay | SNAgenda) {
    if (theAgenda) {
      this.theAgenda = theAgenda;
      this.appointments = this.theAgenda.appointments;
    }
  }

}
